/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocationModel } from '../../models/location-model';

export interface SdkWhatsMyLocationGet$Params {
}

export function sdkWhatsMyLocationGet(http: HttpClient, rootUrl: string, params?: SdkWhatsMyLocationGet$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<LocationModel>> {
  const rb = new RequestBuilder(rootUrl, sdkWhatsMyLocationGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as WearablesStrictHttpResponse<LocationModel>;
    })
  );
}

sdkWhatsMyLocationGet.PATH = '/SDK/WhatsMyLocation';
